// Import 3rd-party dependencies
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';

// Import project-specific dependencies
import { TRENDING_COMPONENT_CONSTS } from '@app/config/constants';
import { SearchDataService } from '@app/services/searchdata/searchdata.service';

enum ETrendingType {
  DOCUMENTS = 'documents',
  HR = 'employee connect',
  IT = 'it support',
  SHAREPOINT = 'sharepoint'
}

@Component({
  selector: 'app-trending',
  templateUrl: './trending.component.html',
  styleUrls: ['./trending.component.css']
})
export class TrendingComponent implements OnInit {
  @ViewChild('selectDropdown') selectDropdown: MatSelect;

  activeIndex: number;
  linksPerPage: number;
  countryList: string[];

  fs = 0;
  ls = 4;

  consts = TRENDING_COMPONENT_CONSTS;

  // Class methods
  constructor(private searchDataService: SearchDataService) {
    this.activeIndex = 0;
    this.searchDataService.getHRConnectCountryList().subscribe((res) => {
      if (res) {
        this.countryList = res;
      }
    });
  }

  ngOnInit(): void {
    this.linksPerPage = this.consts.NUMBER_OF_LINKS;
  }

  showInformation(type: string): void {
    switch (type.toLocaleLowerCase()) {
      case ETrendingType.HR:
        this.activeIndex = 1;
        break;
      case ETrendingType.IT:
        this.activeIndex = 2;
        break;
      case ETrendingType.DOCUMENTS:
      default:
        this.activeIndex = 0;
        break;
    }
  }

  next(): void {
    this.fs = 4;
    this.ls = 8;
  }

  pre(): void {
    if (this.fs >= 4) {
      this.fs -= 4;
    }
    if (this.ls >= 8) {
      this.ls -= 4;
    }
  }
}
